export enum SearchPatternTypeEnum {
  PHONE_NUMBER = 'Numéro de téléphone',
  EMAIL = 'Email',
  POSTAL_CODE = 'Code postal',
  NAME = 'Nom',
  FIDELITY = 'Fidélité',
  ID = 'Identification',
  UNIDENTIFIED = 'Non-identifié',
}
